module.exports = __webpack_public_path__ + "img/226.problem_air_condition.fbac0726.svg";